import { render, staticRenderFns } from "./Table13El.vue?vue&type=template&id=51552354&scoped=true&"
import script from "./Table13El.vue?vue&type=script&lang=ts&"
export * from "./Table13El.vue?vue&type=script&lang=ts&"
import style0 from "./Table13El.vue?vue&type=style&index=0&id=51552354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51552354",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
